import client from "./client";

const BASE = "/v1/sales/invoices";
const REPS = "/v1/sales/reps";

export const invoiceFromOrder = async (body) => (await client.post(`${BASE}/from-order`, body)).data;
export const invoiceFromDelivery = async (body) => (await client.post(`${BASE}/from-delivery`, body)).data;
export const createNote = async (body) => (await client.post(`${BASE}/notes`, body)).data;
export const preflight = async (id) => (await client.get(`${BASE}/${id}/preflight`)).data;
export const issueInvoice = async (id) => (await client.post(`${BASE}/${id}/issue`)).data;
export const einvoiceStatus = async (id) => (await client.get(`${BASE}/${id}/einvoice-status`)).data;
export const voidInvoice = async (id, reason) => (await client.post(`${BASE}/${id}/void`, { reason })).data;
export const payInvoice = async (id, amount, full) =>
  (await client.post(`${BASE}/${id}/payment`, { amount, full })).data;
export const einvoiceJobs = async (status) =>
  (await client.get(`${BASE}/einvoice/jobs`, { params: status ? { status } : {} })).data;
export const dispatchEinvoices = async () => (await client.post(`${BASE}/einvoice/dispatch`)).data;

export const downloadInvoiceXml = async (id, number) => {
  const res = await client.get(`${BASE}/${id}/xml`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${number || id}.xml`;
  link.click();
  window.URL.revokeObjectURL(url);
};

export const teamPerformance = async (month) => (await client.get(`${REPS}/performance`, { params: { month } })).data;
export const saveRepPlan = async (body) => (await client.put(`${REPS}/plan`, body)).data;
export const saveRepTarget = async (body) => (await client.put(`${REPS}/target`, body)).data;
export const approveCommission = async (repId, month) =>
  (await client.post(`${REPS}/${repId}/commission/${month}/approve`)).data;
